import React, { useState } from "react";

import { DropUserSearch } from "./DropUserSearch/DropUserSearch";
import { DropUserInfoLIst } from "./DropUserInfoLIst/DropUserInfoLIst";
import { Wrapper } from "./DropUser.style";
import { PaginationBox } from "components/Pagination/PaginationBox";

// 검색 -> 탈퇴 회원관리 :: (http://localhost:3000/super/search/gone-user)
export const DropUser = () => {
  const [dropUserList, setDropUserList] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [searchData, setSearchData] = useState({});

  return (
    <Wrapper>
      <div>
        <DropUserSearch
          setDropUserList={setDropUserList}
          setPage={setPage}
          currentPage={page}
          pageSize={size}
          setSearchData={setSearchData}
          searchData={searchData}
        />
        <DropUserInfoLIst
          dropUserList={dropUserList}
          setPage={setPage}
          setSize={setSize}
          searchData={searchData}
          setDropUserList={setDropUserList}
        />

        {dropUserList.length !== 0 && (
          <PaginationBox
            totalItemsCount={dropUserList[0]?.cnt}
            page={page}
            setPage={setPage}
            size={size}
          />
        )}
      </div>
    </Wrapper>
  );
};
